var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrafficJamEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15783_13173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7042 15.5015L42.3475 7H42.0524H25.2809H24.9858L24.2235 8.93159",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.295 15.9655L27.122 13H26.7954H8.23191H7.90539L4.18059 22.4168C2.10051 22.4774 1.02419 24.1719 1 26.2538V36.1184H4.95458V39.2655C4.95458 40.7058 6.12765 41.8799 7.57887 41.8799C7.60305 41.8799 9.43618 41.8799 9.46036 41.8799C10.8753 41.8436 12 40.6816 12 39.2655V36.1184H17.2295",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1209 21.5589C24.3201 22.2023 23.8392 22.8547 23.1656 22.8547H11.4868C10.8206 22.8547 10.3407 22.2155 10.5265 21.5757L11.4089 18.5375C11.533 18.1103 11.9244 17.8164 12.3692 17.8164H22.2248C22.6632 17.8164 23.0504 18.1019 23.1801 18.5206L24.1209 21.5589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0237 47.0001L46.0478 50.1039C46.0478 51.6771 47.3129 52.9523 48.8912 53C48.9153 53 51.0599 53 51.084 53C52.6984 53 54.0237 51.7009 54.0237 50.1039L53.9996 47.0001H58.9996V36.0712C58.9755 33.7591 57.7707 31.888 55.4334 31.8165L51.2526 21H50.8912H30.096H29.7346L25.5659 31.8165C23.2406 31.888 22.0237 33.7591 21.9996 36.0712V47.0001H26.9996L27.0237 50.1039C27.0237 51.7009 28.337 53 29.9635 53C29.9996 53 32.1322 53 32.1563 53C33.7346 52.9523 34.9996 51.6771 34.9996 50.1039L34.9755 47.0001H46.0237Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7242 29.6829C47.9505 30.3328 47.468 31.0117 46.7798 31.0117H33.5238C32.8447 31.0117 32.3631 30.3494 32.5725 29.7034L33.5449 26.7034C33.6786 26.291 34.0627 26.0117 34.4962 26.0117H45.7354C46.161 26.0117 46.5399 26.281 46.6798 26.6829L47.7242 29.6829Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15783_13173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 48,
    fill: "white",
    transform: "translate(0 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficJamEvent);
export default __webpack_public_path__ + "static/media/icon-traffic-jam-event.c3ee511189020fa71e3cb4a58f53aaa2.svg";
export { ForwardRef as ReactComponent };